import React from 'react';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { KidIcon } from '@cp/ds/src/icons/kid';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { Stack } from '@cp/ds/src/components/stack';
import { Box } from '@cp/ds/src/components/box';
import { PinIcon } from '@cp/ds/src/icons/pin';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { useDeclination } from '@cp/shared/declination';
import { useTheme } from '@cp/ds/src/hooks';
import { Tokens } from '../const';
import { ChildrenCountProps, ParametersProps } from './model';

const ChildrenCount: React.FC<ChildrenCountProps> = ({ itemChildren, iconSx, sx }) => {
  const declination = useDeclination();
  const theme = useTheme();

  return (
    <Box
      component="div"
      sx={mergeSx(
        { typography: 'caption', color: Tokens.textColor(theme.palette['gray dark']), display: 'flex', alignItems: 'center' },
        sx,
      )}
    >
      <KidIcon fontSize="1.25rem" sx={mergeSx({ mr: 0.75 }, iconSx)} />
      <span>
        {itemChildren.length} {declination(itemChildren.length, DeclinationMnemonic.Child)}:{' '}
        {itemChildren.map((c) => `${c.age} ${declination(c.age, DeclinationMnemonic.Year)}`).join(', ')}
      </span>
    </Box>
  );
};

const ChildWithDisabilities: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: '8px',
        px: 1,
        py: 0.5,
        backgroundColor: 'pink light',
        typography: 'small text bold',
        color: Tokens.textColor(theme.palette.gray),
      }}
    >
      Особый ребенок
    </Box>
  );
};

const RegularSpecialist: React.FC = () => {
  return (
    <Box
      sx={{
        borderRadius: '8px',
        px: 1,
        py: 0.125,
        backgroundColor: 'gray light',
        typography: 'caption bold',
        color: 'gray',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <PinIcon fontSize="1.25rem" sx={{ mr: 0.5 }} />
      <span>Постоянный специалист</span>
    </Box>
  );
};

export const Parameters: React.FC<ParametersProps> = (props) => {
  const { data, childrenCountProps, sx } = props;

  return (
    <Stack direction="row" sx={mergeSx({ gap: 0.75, alignItems: 'center', flexWrap: 'wrap' }, sx)}>
      {data.children ? <ChildrenCount itemChildren={data.children} {...childrenCountProps} /> : null}
      {data.childWithDisabilities ? <ChildWithDisabilities /> : null}
      {data.type === CatalogItemType.Vacancy && data.regularSpecialist ? <RegularSpecialist /> : null}
    </Stack>
  );
};
